module.exports = __webpack_public_path__ + "img/line_QR.5a2bea22.jpg";